var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "allergy-kpis__nav" },
    [
      _c(
        "ul",
        { staticClass: "nav h-center-align", attrs: { id: "tabs" } },
        _vm._l(_vm.sectionsList, function(section, index) {
          return _c("NavTab", {
            key: "section-" + index,
            attrs: {
              "active-section": _vm.activeSection,
              "section-name": section.label,
              "section-key": section.value
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("StoreConnectedSelect", {
        staticClass: "allergy-kpis__mobile-dropdown",
        attrs: {
          store: "allergyKpis",
          name: "activeSection",
          options: _vm.sectionsList,
          "close-on-select": ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }